import { InboundProcess, OutboundProcess } from '@features/supplyChain/types';
import { StageTone } from './FulfilmentStageTracker';
import { buildOutboundStages } from './outboundStages';
import { buildInboundStages } from './inboundStages';

export type SupplyChainProcess = InboundProcess | OutboundProcess;

const noop = () => {};

const outboundStepLabels: Record<string, string> = {
  order: 'Order',
  despatch: 'Despatch',
  picking: 'Picking',
  transport: 'Transport',
  shipment: 'Shipment',
  delivery: 'Delivery',
  fulfilledExternally: 'Fulfilled externally',
};

const inboundStepLabels: Record<string, string> = {
  order: 'Order',
  shipment: 'Shipment',
  grn: 'GRN',
};

export interface ProcessStep {
  key: string;
  label: string;
  isComplete: boolean;
  doneTone?: StageTone;
}

export function isOutbound(
  process: SupplyChainProcess
): process is OutboundProcess {
  return process.type === 'Outbound';
}

export function getProcessSteps(process: SupplyChainProcess): ProcessStep[] {
  const stages = isOutbound(process)
    ? buildOutboundStages(process, {
        onViewDespatch: noop,
        onViewPicking: noop,
        onViewShipment: noop,
        onViewProofOfDelivery: noop,
      })
    : buildInboundStages(process, {
        onViewShipment: noop,
        onViewGoodsReceivedNote: noop,
      });
  const labels = isOutbound(process) ? outboundStepLabels : inboundStepLabels;
  return stages.map((stage) => ({
    key: stage.key,
    label: labels[stage.key] ?? stage.doneLabel,
    isComplete: stage.isComplete,
    doneTone: stage.doneTone,
  }));
}

export function latestCompleteStepKey(steps: ProcessStep[]): string {
  const lastComplete = [...steps].reverse().find((step) => step.isComplete);
  return lastComplete?.key ?? steps[0]?.key ?? '';
}
